import { Component } from "react"
import PropTypes from "prop-types"
import { capitalize, chain, filter, map, split, toUpper } from "lodash"
import { Drawer, AppBar, Toolbar, Typography, List, InputBase, InputAdornment } from "@mui/material"
import { Search } from "@mui/icons-material"
import FacetListItem from "../list-item"
import { FACET_TYPE } from "../../shapes"
import { getTierName } from "helpers/classification"

export default class FullFacetsList extends Component {
  static propTypes = {
    type: PropTypes.string,
    facetTypes: PropTypes.arrayOf(FACET_TYPE).isRequired,
    close: PropTypes.func.isRequired,
    toggleFacet: PropTypes.func.isRequired,
    toggleClassificationFacets: PropTypes.func.isRequired,
    classifications: PropTypes.object.isRequired,
  }

  constructor(...props) {
    super(...props)

    this.state = {
      search: "",
    }
  }

  setSearch = (event) => {
    this.setState({
      search: event.target.value,
    })
  }

  onClick = (id) => {
    const { type, toggleFacet } = this.props
    toggleFacet(type, id)
  }

  onClickClassification = (type, id, tier, selected) => {
    const { toggleClassificationFacets } = this.props
    toggleClassificationFacets(type, tier, [id], selected)
  }

  onClose = () => {
    const { close } = this.props
    this.setState({
      search: "",
    })

    close()
  }

  render() {
    const { type, facetTypes, classifications } = this.props
    const { search } = this.state
    let isClassification = false
    let facets
    // Combined type for classifications: [classificationId].[tierId]
    const [cId, tierId] = split(type, ".")
    if (tierId) {
      facets = chain(facetTypes).find(f => f.type === "classification").get(`facets.${type}.facets`).value()
      isClassification = true
    } else {
      facets = chain(facetTypes)
        .find(facetType => type === facetType.type)
        .get("facets")
        .value()
    }

    if (search) {
      const lowSearch = search.toLowerCase()
      facets = filter(facets, ({ label, id }) => label.toLowerCase().includes(lowSearch) || id.toLowerCase().includes(lowSearch))
    }

    return (
      <Drawer anchor="left" open={!!type} onClose={this.onClose} className="components_full-facets-list">
        <AppBar position="sticky">
          <Toolbar className="header">
            <Typography
              variant="h6"
              noWrap
              sx={{
              color: "inherit",
            }}
            >
              {!isClassification ? capitalize(type) : `${toUpper(cId)} ${getTierName(classifications, cId, tierId)}`}
            </Typography>
            <InputBase
              placeholder="Search…"
              value={search}
              onChange={this.setSearch}
              className="search"
              startAdornment={
                <InputAdornment position="start">
                  <Search color="inherit" />
                </InputAdornment>
              }
            />
          </Toolbar>
        </AppBar>
        {type && <List>
          {map(facets, facet => <FacetListItem
            key={facet.id}
            {...facet}
            onClick={() => !isClassification ? this.onClick(facet.id) : this.onClickClassification(cId, facet.id, tierId, !facet.selected)}
          />)}
        </List>}
      </Drawer>
    )
  }
}
